module.exports = __webpack_public_path__ + "img/m-hd.30710b80.jpg";